import common from './common';

export default class AchievementManager {
	constructor() {
		this._achievements = [];
		this._trackers = {};

		this.signals = {};
		this.signals.unlock = new P3.utils.MiniSignal();
		this._init();
	}

	_init() {
		for (let i = 0; i < 15; i++) {
			this._achievements[i] = false;
		}
	}

	/**
     * Sets any index {which} in AchievementManager.achievements to true. If scenario is given, this unlocks only if current scenario matches passed scenario
     * @param which         {Number}    The achievement to unlock
     * @param scenario      {String}    The scenario to unlock it in. Leave empty for any scenario.
     */
	unlockAchievement(which, scenario = null) {
		if (which > this._achievements.length) {
			return;
		}
		if (this._achievements[which]) {
			return;
		}

		common.tracking.track(new P3.TrackingDataGtagEvent('unlock_achievement', {
			event_category: 'UI',
			event_type: 'unlock_achievement',
			page_container: common.selectedLevel,
			title: `achievement_${which + 1}`,
		}));

		if (scenario === null) {
			this._achievements[which] = true;
			common.score += 1000;
			this.signals.unlock.dispatch();
		} else if (scenario === common.selectedLevel) {
			this._achievements[which] = true;
			common.score += 1000;
			this.signals.unlock.dispatch();
		}
	}

	/**
     * Sets a key in AchievementManager.trackers to a value. Used to track achievements that require multiple things built, e.g. firewalls in Wildfire
     * @param key       {string}        The key to store value in
     * @param value     {*}             The value to store in key
     */
	setTracker(key, value) {
		this._trackers[key] = value;
	}

	get trackers() {
		return this._trackers;
	}

	get achievements() {
		return this._achievements;
	}

	get unlocked() {
		const unlocked = [];

		for (const a of this._achievements) {
			if (a) {
				unlocked.push(a);
			}
		}

		return unlocked;
	}
}
